const ErrorIcon = () => (
	<div style={{ width: 115, height: 115 }}>
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 133 133'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='error-group' fill='none' stroke='none'>
				<circle
					id='circle'
					cx='66.5'
					cy='66.5'
					r='54.5'
					fill='#e74c3c'
				/>
				<line
					id='line1'
					x1='45'
					y1='45'
					x2='88'
					y2='88'
					stroke='#fff'
					strokeWidth='6'
					strokeLinecap='round'
				/>
				<line
					id='line2'
					x1='88'
					y1='45'
					x2='45'
					y2='88'
					stroke='#fff'
					strokeWidth='6'
					strokeLinecap='round'
				/>
			</g>
		</svg>

		<style jsx>{`
			#error-group {
				transform-origin: center;
				animation: pulse 0.4s ease-in-out 1.05s both;
			}

			#circle {
				transform: scale(0);
				transform-origin: center;
				animation: pop-in 0.3s ease-out forwards;
			}

			#line1,
			#line2 {
				stroke-dasharray: 60;
				stroke-dashoffset: 60;
				animation: draw-x 0.35s ease-out forwards;
				animation-delay: 0.5s;
			}

			#line2 {
				animation-delay: 0.65s;
			}

			@keyframes pop-in {
				0% {
					transform: scale(0);
				}
				100% {
					transform: scale(1);
				}
			}

			@keyframes draw-x {
				to {
					stroke-dashoffset: 0;
				}
			}

			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				50% {
					transform: scale(1.08);
				}
				100% {
					transform: scale(1);
				}
			}
		`}</style>
	</div>
);

export default ErrorIcon;
